'use client';

import { useGlossaryDictionary } from '@/app/[locale]/(learning)/glossary/_component/DictionaryProvider';
import NavigationLink from '@/components/NavigationLink';
import { Separator } from '@/components/ui/separator';
import { AnimatePresence, domAnimation, LazyMotion } from 'motion/react';
import * as motion from 'motion/react-m';

export default function DictionaryGroups({ isLatinOnly, headerSize }) {
  const { filteredGroups } = useGlossaryDictionary();

  return (
    <LazyMotion features={domAnimation}>
      <div className='flex flex-col gap-7 xl:gap-14 mt-1'>
        <AnimatePresence initial={false} mode={!isLatinOnly ? 'wait' : 'popLayout'}>
          {filteredGroups.map(([letter, list = []], index) => (
            <motion.div
              animate={{
                opacity: 1,
                y: 0,
                transition: { delay: 0.15 * index }
              }}
              initial={{ opacity: 0, y: -70 }}
              exit={{ opacity: 0, y: 10 }}
              key={letter}
              layout
              style={{ '--height': `${headerSize.height}px` }}
              className='xs:scroll-mt-[calc(var(--height)+var(--section-py))]'
              id={`${letter}`}
            >
              {isLatinOnly && (
                <p className='text-5xl md:text-6xl lg:text-8xl font-semibold text-primary leading-tight uppercase'>
                  {letter}
                </p>
              )}
              <div className='grid grid-cols-[repeat(auto-fill,minmax(25ch,1fr))] gap-y-2 gap-x-4 mt-4 lg:mt-[2rem]'>
                <AnimatePresence initial={false}>
                  {list.map((item, index) => (
                    <motion.div
                      key={item.slug}
                      animate={{
                        opacity: 1,
                        x: 0,
                        transition: { delay: 0.05 * index, duration: 0.25 }
                      }}
                      initial={{ opacity: 0, x: 50 }}
                      layout
                    >
                      <NavigationLink
                        href={`/glossary/${item.slug}`}
                        className='inline-block px-1 md:px-2 truncate w-[25ch]'
                      >
                        {item.title}
                      </NavigationLink>
                    </motion.div>
                  ))}
                </AnimatePresence>
              </div>
              <Separator className='bg-zinc-200 mt-9' />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </LazyMotion>
  );
}
